import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const CGU = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 section-padding">
        <div className="container mx-auto max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-8">
            Conditions Générales d'Utilisation
          </h1>

          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                1. Objet
              </h2>
              <p>
                Les présentes Conditions Générales d'Utilisation (ci-après "CGU") ont pour 
                objet de définir les conditions d'accès et d'utilisation de la plateforme 
                GoBledPro (ci-après "la Plateforme"), accessible à l'adresse www.gobledpro.com.
              </p>
              <p>
                GoBledPro est une plateforme de mise en relation entre des utilisateurs 
                souhaitant envoyer des colis (ci-après "les Clients") et des transporteurs 
                professionnels indépendants (ci-après "les Transporteurs").
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                2. Rôle de GoBledPro
              </h2>
              <div className="bg-secondary/10 border border-secondary/20 rounded-xl p-4 my-4">
                <p className="text-secondary font-medium">
                  ⚠️ GoBledPro agit exclusivement en qualité de plateforme de mise en relation. 
                  GoBledPro n'est pas un transporteur et ne réalise aucune prestation de transport.
                </p>
              </div>
              <p>
                Le transport des colis est assuré par des transporteurs indépendants, 
                professionnels et vérifiés par GoBledPro. Chaque transporteur est seul 
                responsable de la bonne exécution de ses prestations de transport.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                3. Inscription et accès
              </h2>
              <h3 className="text-xl font-heading font-medium text-foreground mb-2">
                3.1 Pour les Clients
              </h3>
              <p>
                L'accès à la Plateforme est gratuit. Les Clients peuvent déposer une 
                demande de transport sans inscription préalable en remplissant le 
                formulaire dédié.
              </p>
              <h3 className="text-xl font-heading font-medium text-foreground mb-2 mt-4">
                3.2 Pour les Transporteurs
              </h3>
              <p>
                L'inscription des Transporteurs est soumise à un processus de vérification 
                comprenant : vérification d'identité, vérification de l'activité 
                professionnelle (SIRET, licence de transport), et vérification de 
                l'assurance marchandises.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                4. Fonctionnement du service
              </h2>
              <ol className="list-decimal list-inside space-y-2">
                <li>Le Client dépose une demande de transport via le formulaire en ligne</li>
                <li>GoBledPro analyse la demande et identifie les Transporteurs adaptés</li>
                <li>Le Client est mis en relation directe avec le(s) Transporteur(s)</li>
                <li>Le Client et le Transporteur conviennent des modalités du transport</li>
                <li>Le transport est réalisé par le Transporteur</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                5. Obligations des Clients
              </h2>
              <p>Le Client s'engage à :</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Fournir des informations exactes et complètes</li>
                <li>Décrire précisément le contenu des colis</li>
                <li>Ne pas expédier de marchandises interdites ou réglementées</li>
                <li>Respecter les conditions convenues avec le Transporteur</li>
                <li>Signaler tout incident dans les meilleurs délais</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                6. Obligations des Transporteurs
              </h2>
              <p>Le Transporteur s'engage à :</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Disposer de toutes les autorisations légales nécessaires</li>
                <li>Maintenir une assurance marchandises transportées valide</li>
                <li>Respecter les réglementations douanières France-Maroc</li>
                <li>Assurer le transport dans les conditions convenues</li>
                <li>Informer le Client de tout incident ou retard</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                7. Responsabilité
              </h2>
              <p>
                GoBledPro ne peut être tenu responsable des dommages directs ou indirects 
                résultant de l'exécution des prestations de transport, celles-ci relevant 
                de la seule responsabilité des Transporteurs.
              </p>
              <p>
                GoBledPro s'engage à vérifier l'identité et le statut professionnel des 
                Transporteurs mais ne garantit pas l'absence de tout risque lié au transport.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                8. Données personnelles
              </h2>
              <p>
                GoBledPro collecte et traite les données personnelles des utilisateurs 
                conformément au RGPD et à la loi Informatique et Libertés. Les données 
                sont utilisées uniquement pour le fonctionnement du service et ne sont 
                pas cédées à des tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                9. Marchandises interdites
              </h2>
              <p>
                Sont interdites au transport : les matières dangereuses, explosives ou 
                inflammables, les armes, les stupéfiants, les contrefaçons, les animaux 
                vivants, et toute marchandise dont le transport est interdit par la 
                législation française ou marocaine.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                10. Modification des CGU
              </h2>
              <p>
                GoBledPro se réserve le droit de modifier les présentes CGU à tout moment. 
                Les utilisateurs seront informés de toute modification substantielle. 
                L'utilisation continue de la Plateforme après modification vaut 
                acceptation des nouvelles CGU.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                11. Litiges
              </h2>
              <p>
                En cas de litige entre un Client et un Transporteur, les parties sont 
                invitées à rechercher une solution amiable. GoBledPro peut, à titre 
                de bonne volonté, faciliter la médiation mais n'est pas partie au litige.
              </p>
              <p>
                À défaut de résolution amiable, les tribunaux français seront compétents.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                12. Contact
              </h2>
              <p>
                Pour toute question relative aux présentes CGU :<br />
                Email : gobledpro@gmail.com<br />
                Téléphone : +33 9 55 44 39 02
              </p>
            </section>

            <p className="text-sm text-muted-foreground pt-8 border-t border-border">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGU;
